// import.meta.env only exists under Vite — Playwright/esbuild test
// transpilation leaves it undefined, so guard before reading it.
const IS_DEV =
  import.meta.env?.MODE === 'development' || import.meta.env?.VITE_DEBUG === 'true';

export const logger = {
  log: (...args) => {
    if (IS_DEV) {
      console.log(...args);
    }
  },
  
  debug: (...args) => {
    if (IS_DEV) {
      console.debug(...args);
    }
  },
  
  info: (...args) => {
    if (IS_DEV) {
      console.info(...args);
    }
  },
  
  warn: (...args) => {
    console.warn(...args);
  },
  
  error: (...args) => {
    console.error(...args);
  }
};

export default logger;
